/**
 * Resolves with the promise's value, or with `undefined` once `ms` has passed, whichever comes
 * first. A rejection also resolves `undefined`, because a caller reaching for this has already
 * decided to proceed regardless of the outcome. Meant for best-effort work that must not block what
 * follows, such as flushing an analytics event before a hard navigation. The original promise is
 * left to settle on its own.
 */
export const settleWithin = <T>(promise: Promise<T>, ms: number): Promise<T | undefined> =>
	new Promise(resolve => {
		const timer = setTimeout(() => resolve(undefined), ms);
		promise.then(
			value => {
				clearTimeout(timer);
				resolve(value);
			},
			() => {
				clearTimeout(timer);
				resolve(undefined);
			},
		);
	});
